"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12.588 4.191a1 1 0 0 1 .363.5l1.347 4.145h4.36a1 1 0 0 1 .587 1.81l-3.526 2.562 1.347 4.146a1 1 0 0 1-1.539 1.118L12 15.91l-3.526 2.562a1.001 1.001 0 0 1-1.539-1.118l1.347-4.146-3.527-2.562a1 1 0 0 1 .587-1.809h4.36l1.347-4.146a1 1 0 0 1 1.539-.5ZM12 8.236l-.62 1.91a1.002 1.002 0 0 1-.951.691H8.421l1.624 1.18a1 1 0 0 1 .363 1.118l-.62 1.91 1.625-1.18a1 1 0 0 1 1.175 0l1.624 1.18-.62-1.91a1 1 0 0 1 .363-1.118l1.625-1.18h-2.008a1 1 0 0 1-.952-.69L12 8.236Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
    clipRule: "evenodd"
  })]
});